// Chakra imports
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Text,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalContent,
  ModalFooter,
  useColorModeValue,
  Center,
  useToast,
} from "@chakra-ui/react";
import { CheckIcon, InfoIcon } from '@chakra-ui/icons';
// Custom components
import Card from "components/card/Card.js";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { decryptData, encryptData, URL_WEB_BACKEND } from "CustomUtil";

export default function EditUsername(props) {
  const { used, total, ...rest } = props;
  const [userid, setUserid] = useState();
  const [username, setUsername] = useState('');
  const [fullname, setFullname] = useState('');
  const authdata = decryptData(localStorage.getItem("authinfosemakinpas"));
  const authid = decryptData(localStorage.getItem("authidsemakinpas"));
  const [statusConfUpdate, setStatusConfUpdate] = useState(false);
  const [titleDialog, setTitleDialog] = useState('title');
  const [descDialog, setDescDialog] = useState('desc');
  const [statusInfoDialog, setStatusInfoDialog] = useState(false);
  const [infoDialogIcon, setInfoDialogIcon] = useState(1);
  const toast = useToast();

  useEffect(() => {
    getAdmindata();
  }, []);

  const getAdmindata = async () => {
    const profile = await axios.get(URL_WEB_BACKEND + '/profile', {
      headers: {
        'Authorization': 'Bearer ' + authdata
      }
    });
    setUserid(profile.data.userid);
    refreshAdmindata(profile.data.userid);
  }

  const refreshAdmindata = async (id) => {
    const profileupdate = await axios.get(URL_WEB_BACKEND + '/profile/' + id, {
      headers: {
        'Authorization': 'Bearer ' + authdata
      }
    });
    setUsername(profileupdate.data.username);
    setFullname(profileupdate.data.fullname);
    localStorage.setItem("authfullnamesemakinpas", encryptData(profileupdate.data.fullname));
  }

  const confUpdate = () => {
    if (username === '' || fullname === '') {
      toast({
        status: 'error',
        title: 'Proses Gagal',
        description: 'Masih ada kolom yang kosong',
        position: 'bottom-right',
        isClosable: true,
      })
    } else {
      setStatusConfUpdate(true);
    }
  }

  const exeSendnotif = async (title, desc) => {
    await axios.post(URL_WEB_BACKEND + '/notifs', {
      id_user: authid,
      judul: title,
      isi: desc,
      tanggal: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000).toJSON().slice(0, 19).replace('T', ' '),
      read: 0
    }, {
      headers: {
        'Authorization': 'Bearer ' + authdata
      }
    }).then(res => {
      if (res.status === 201) {
        showInfoDialog('Berhasil', 'Profil berhasil diperbarui', 0).then(() => {
          refreshAdmindata(userid);
        })
      } else {
        let reskey = Object.keys(res.response.data.messages)[0];
        showInfoDialog('Error Ubah Profil dengan status ' + res.response.status, res.response.messages[reskey], 1)
      }
    }).catch(err => {
      let errkey = Object.keys(err.response.data.messages)[0];
      showInfoDialog('Error Ubah Profil dengan status ' + err.response.status, err.response.data.messages[errkey], 1)
    })
  }

  const exeUpdate = async () => {
    setStatusConfUpdate(false);
    await axios.put(URL_WEB_BACKEND + '/profile/' + userid, {
      username: username,
      fullname: fullname,
      role: decryptData(localStorage.getItem("authrolesemakinpas"))
    }, {
      headers: {
        'Authorization': 'Bearer ' + authdata
      }
    }).then(res => {
      if (res.status === 200) {
        exeSendnotif('Berhasil Memperbarui Profil', 'Pembaruan profil telah berhasil dilakukan');
      } else {
        let reskey = Object.keys(res.response.data.messages)[0];
        showInfoDialog('Error Ubah Profil dengan status ' + res.response.status, res.response.messages[reskey], 1)
      }
    }).catch(err => {
      let errkey = Object.keys(err.response.data.messages)[0];
      showInfoDialog('Error Ubah Profil dengan status ' + err.response.status, err.response.data.messages[errkey], 1)
    })
  }

  function showInfoDialog(title, desc, infoicon) {
    setTitleDialog(title); setDescDialog(desc); setInfoDialogIcon(infoicon); setStatusInfoDialog(true);
  }

  const viewInfoDialog = () => {
    return (
      <Modal closeOnOverlayClick={true} isCentered isOpen={statusInfoDialog}>
        <ModalOverlay
          bg='blackAlpha.300'
          backdropFilter='blur(10px) hue-rotate(10deg)'
        />
        <ModalContent>
          <ModalHeader>{titleDialog}</ModalHeader>
          <ModalBody>
            <Center>
              {infoDialogIcon
                ? <InfoIcon w={16} h={16} color="blue.500" />
                : <CheckIcon w={16} h={16} color="green.500" />
              }
            </Center>
            <Center mt={8}>
              <Text fontSize='large'>{descDialog}</Text>
            </Center>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => { setStatusInfoDialog(false) }}>OK</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )
  }

  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  return (
    <Card {...rest} mb='20px' align='center' p='20px'>
      <Flex h='100%' direction={{ base: "column", "2xl": "row" }}>
        <Flex direction='column' pe='44px'>
          {viewInfoDialog()}
          <Modal closeOnOverlayClick={false} isCentered isOpen={statusConfUpdate}>
            <ModalOverlay
              bg='blackAlpha.300'
              backdropFilter='blur(10px) hue-rotate(10deg)'
            />
            <ModalContent>
              <ModalHeader>Ubah Profil</ModalHeader>
              <ModalBody>
                <Text fontSize='large'>Yakin ingin mengubah profil?</Text>
              </ModalBody>
              <ModalFooter>
                <Button colorScheme='red' mr={3} onClick={() => { exeUpdate() }}>
                  Iya, Lanjutkan
                </Button>
                <Button onClick={() => { setStatusConfUpdate(false) }}>Batal</Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
          <Text
            color={textColorPrimary}
            fontWeight='bold'
            textAlign='start'
            fontSize='2xl'
            mt={{ base: "5px", "2xl": "5px" }}>
            Ubah Profil
          </Text>
          <Text
            color={textColorSecondary}
            fontSize='md'
            my={{ base: "auto", "2xl": "10px" }}
            mx='auto'
            textAlign='start'>
            Username tidak boleh sama dengan username aktif saat ini dan username milik akun lain.
          </Text>
          <Flex w='100%' mt={{ base: "20px", "2xl": "20px" }} >
            <FormControl id="profil" isRequired>
              <FormLabel>Username</FormLabel>
              <Input id='profil1' placeholder="Username" borderRadius="16px" value={username} onChange={(e) => setUsername(e.target.value)} />
              <FormLabel>Fullname</FormLabel>
              <Input id='profil2' placeholder="Fullname" borderRadius="16px" value={fullname} onChange={(e) => setFullname(e.target.value)} />
              <Button
                me='100%'
                mb='50px'
                w='140px'
                minW='140px'
                mt={{ base: "20px", "2xl": "10px" }}
                variant='brand'
                fontWeight='500'
                onClick={confUpdate}>
                Simpan
              </Button>
            </FormControl>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
